
import { defineComponent } from "vue";

import { mapState, mapActions } from "pinia";
import { useBillStore } from "@/stores/BillStore";

export default defineComponent({
  computed: {
    ...mapState(useBillStore, ["waitPayment"]),
  },
  methods: {
    ...mapActions(useBillStore, ["cancelPayment"]),
  },
});
